import React from 'react';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import useServicesPerMonthPerYearTotalChart from './hooks/useServicesPerMonthPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ServicesPerMonthPerYearTotal = ({ height = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { series, subtitles } = useServicesPerMonthPerYearTotalChart();

    return (
        <SimpleBars
            title={`Evolução ${module.sectionTitle} Mensal no Ano Selecionado`}
            series={series}
            values={[]}
            subtitles={subtitles}
        />
    );
};
